import { Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { DownArrow, StepContainer, StepContent, StepNavigator } from '../../components';
import { Button } from '@uplift/ui-v2';
import { useL10n } from '@uplift/hooks';


export type PsychInterstitialProps = {
  onNext: () => void;
};

export const PsychInterstitial: React.FC<PsychInterstitialProps> = props => {
  const { classes } = usePsychInterstitialStyles();

  const l10n = useL10n();


  return (
    <StepContainer className={classes.container}>
      <StepContent className={classes.content}>
        <div>
          <DownArrow />
        </div>
        <Typography variant="overline">
          Up Next
        </Typography>
        <Typography variant="h2" className={classes.header}>
          Book your&nbsp;
          <Typography component="span" color="secondary" variant="inherit" className={classes.header}>psychiatry consultation</Typography>
        </Typography>
        <div>
          <Typography className={classes.whatToExpect}>What you can expect</Typography>
          <br />
          <Typography>
            During your initial consultation, your provider will ask about your mental health history and current challenges to help you explore treatment options.
          </Typography>
          <Typography sx={{ marginTop: 2 }}  color="textSecondary" fontStyle="italic" fontSize="1rem" textAlign="center">
              {l10n.findPsychiatrist.noCSWarning}
          </Typography>

        </div>
      </StepContent>
      <StepNavigator>
        <Button variant="contained" color="secondary" onClick={props.onNext}>Next</Button>
      </StepNavigator>
    </StepContainer>
  );
};

const usePsychInterstitialStyles = makeStyles({ name: 'PsychInterstitial' })(theme => ({
  container: {
    background: 'linear-gradient(205.7deg, #F7F2FF 30.17%, #FFFFFF 83.75%)',
    [theme.breakpoints.up('md')]: {
      background: 'unset',
    },
    position: 'relative',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    paddingTop: 0,
    [theme.breakpoints.up('md')]: {
      gap: theme.spacing(3),
    },
  },
  header: {
    fontSize: '34px',
  },
  whatToExpect: {
    fontWeight: 600,
    marginTop: theme.spacing(2),
    [theme.breakpoints.up('md')]: {
      marginTop: theme.spacing(1),
    }
  }
}));
